import { z } from 'zod';

/** Pinterest ad account ids are numeric; the backend refuses anything else with 400. */
export const adAccountPickSchema = z.object({
  adAccountId: z.string().regex(/^\d{1,18}$/, { error: 'social:validation.adAccount' }),
});

export type AdAccountPickForm = z.infer<typeof adAccountPickSchema>;
